import React, { createContext, useContext, useState } from 'react';

const MultiBuilderContext = createContext(null);

/**
 * Holds the Multi Builder bet-slip state (selected legs + the bookmaker filter
 * that is locked to the slip's anchor book). Lifting this above the router lets
 * the slip survive navigation away from the Multi Builder — e.g. deep-linking a
 * leg into the Prop Tool and pressing Back — instead of resetting every time the
 * page component unmounts.
 *
 * Only the persistent slip data lives here. Transient, page-local concerns
 * (loading flags, countdown, filter modal, season view, etc.) stay inside the
 * MultiBuilder component.
 */
export const useMultiBuilder = () => {
    const context = useContext(MultiBuilderContext);
    if (!context) {
        throw new Error('useMultiBuilder must be used within a MultiBuilderProvider');
    }
    return context;
};

export const MultiBuilderProvider = ({ children }) => {
    const [selectedLegs, setSelectedLegs] = useState([]);
    const [bookmakerFilter, setBookmakerFilter] = useState('all');

    return (
        <MultiBuilderContext.Provider
            value={{ selectedLegs, setSelectedLegs, bookmakerFilter, setBookmakerFilter }}
        >
            {children}
        </MultiBuilderContext.Provider>
    );
};
